
/* Essence Days hero (Oct 6): the first hero slide carries the sale. Static HTML ships the 25% copy (no flash during
   the 25% days); this swaps to the 15% copy from Thu Oct 8 00:00 MT and back to the evergreen brand copy from
   Sat Oct 10 00:00 MT, matching the automatic discounts. window.esHeroSale(ms) re-applies for a given time (tests).
   Remove after the sale (or the evergreen branch simply keeps running). */
(function(){
  var E=document.getElementById('heroSaleEyebrow'),H=document.getElementById('heroSaleH1'),
      P=document.getElementById('heroSaleSub'),C=document.getElementById('heroSaleCta');
  if(!E||!H||!P||!C)return;
  var COPY={
    '25':['essence days &middot; ends wednesday','<span class="g">25% off</span><br>everything.',
          'every ring, oil, kit, and bundle, taken off at checkout. no code needed. spend $50 and the pearl soaking bay is on us.','shop the sale'],
    '15':['essence days &middot; final days, ends friday','<span class="g">15% off</span><br>everything.',
          'last call on every ring, oil, kit, and bundle, taken off at checkout. no code needed. spend $50 and the pearl soaking bay is on us.','shop the sale'],
    'off':['a scent ring, worn under your nose','how do you want<br>to <span class="g">feel</span> today?',
          'wearable aromatherapy for real days. night shifts, long flights, loud offices, bad traffic, and everything else your nose already knows how to handle.','shop everything']
  };
  function apply(t){
    var k=t>=Date.UTC(2026,9,10,6,0)?'off':(t>=Date.UTC(2026,9,8,6,0)?'15':'25');
    var c=COPY[k];E.innerHTML=c[0];H.innerHTML=c[1];P.innerHTML=c[2];C.textContent=c[3];
    return k;
  }
  window.esHeroSale=apply;
  apply(Date.now());
})();
